<div [hidden]="newUser">
  <app-filterable-table
    #userTable
    [tableView]="userTableView"
    [options]="userTableOptions"
  ></app-filterable-table>
</div>

<div [hidden]="!newUser">
  <p>
    Enter the user's email address. If the user already exists, select the user
    to add to this account. Otherwise, you'll be prompted to add the rest of the
    user's information.
  </p>

  <app-edit-user
    (cancelled)="cancelAddUser_callback()"
    (saved)="handleNewUserSaved_callback($event)"
    (cancelled)="handleNewUserCancelled_callback()"
    (keydown.escape)="cancelAddUser_callback()"
  ></app-edit-user>
</div>

<div [hidden]="newUser || !enableEditing">
  <input
    type="button"
    value="Add user"
    class="button_primary button_var_2"
    (click)="btnAddUser_click()"
    (keydown.enter)="btnAddUser_click()"
  />
</div>
